import React from 'react'
import { observer } from 'mobx-react'
import { Modal, Button } from 'react-bootstrap'
import { i18nTranslate } from 'src/utils'
import { multipleSubscriptionContainer } from 'src/models'
import { ExistingSubscriptionDetails } from './ExistingSubscriptionDetails'
import './styles.scss'

@observer
class MultipleSubscriptionCart extends React.Component {
  componentDidMount = () => {
    const subscriptionList =
      multipleSubscriptionContainer?.allSubscriptionListResponse
        ?.subscriptions || []

    let availableSubscriptionGroup = {}
    if (subscriptionList?.length) {
      availableSubscriptionGroup =
        subscriptionList.find(subscriptionGroup => {
          const isAlreadySubscribed =
            multipleSubscriptionContainer.checkIsSomeCartItemAlreadyInSubscribedGroup(
              subscriptionGroup
            )
          const isPaymentInProcess =
            subscriptionGroup?.properties?.paymentInProcess === 'true'
          return !(isAlreadySubscribed || isPaymentInProcess)
        }) || {}
    }

    if (Object.keys(availableSubscriptionGroup)?.length) {
      multipleSubscriptionContainer.selectedSubscriptionOption =
        availableSubscriptionGroup?.id || ''
    } else {
      multipleSubscriptionContainer.selectedSubscriptionOption =
        'newSubscription'
      multipleSubscriptionContainer.subscriptionOption = 'startNewSubscription'
    }
  }

  handleSubscriptionContinue = () => {
    this.props?.handleAddToSelectedSubscriptionList()
  }

  handleSubscriptionOptionChange = (value = '') => {
    multipleSubscriptionContainer.selectedSubscriptionOption = value
    multipleSubscriptionContainer.subscriptionOption =
      value === 'newSubscription' ? 'startNewSubscription' : 'addToExisting'
  }

  renderContinueButton = () => {
    const disableCheckoutButton = this.props.checkoutDisableInfo?.()
    const disableContinueButton = disableCheckoutButton?.isDisabled || false
    const continueText = i18nTranslate('common.continue', 'Continue', {
      isNextGenTranslations: true,
    })

    return (
      <Button
        className="subscription-continue-button w-100"
        data-testid="qa-subscription-continue-button"
        disabled={disableContinueButton}
        onClick={this.handleSubscriptionContinue}>
        {continueText}
      </Button>
    )
  }

  renderExistingSubscriptionList = () => {
    const subscriptionList =
      multipleSubscriptionContainer?.allSubscriptionListResponse
        ?.subscriptions || []

    if (subscriptionList?.length) {
      return (
        <ExistingSubscriptionDetails
          subscriptionList={subscriptionList}
          handleSubscriptionOptionChange={this.handleSubscriptionOptionChange}
        />
      )
    }

    return <></>
  }

  renderNewSubscriptionOption = () => {
    const startNewSubscriptionText = i18nTranslate(
      'cartCreateNewSubscriptionComponent.createNewSubscription',
      'Start a new Subscription',
      { isNextGenTranslations: true }
    )

    const frequencyChangeText = i18nTranslate(
      'subscriptionSelector.createNewSubscriptionNotesText',
      'Select delivery frequency at Checkout.',
      { isNextGenTranslations: true }
    )

    return (
      <>
        <input
          type="radio"
          name="multiSubscriptionOption"
          aria-label={startNewSubscriptionText}
          key={'option' + 'newSubscription'}
          id="newSubscription"
          onChange={() => {
            this.handleSubscriptionOptionChange('newSubscription')
          }}
          checked={
            multipleSubscriptionContainer.selectedSubscriptionOption ===
            'newSubscription'
          }
          data-testId="qa-new-subscription-option"
        />
        <label
          htmlFor={'newSubscription'}
          aria-label={startNewSubscriptionText}
          className={`start-new-subscription-label-wrapper subscription-option-details-wrapper`}>
          <div className="subscription-options-details">
            <p className="start-new-subscription-label">
              {startNewSubscriptionText}
            </p>
            <span className="frequency-change-text">{frequencyChangeText}</span>
          </div>
        </label>
      </>
    )
  }

  render() {
    const {
      handleSelectSubscriptionModalClose = function () {},
      showModal = false,
    } = this.props
    const selectSubscriptionTitle = i18nTranslate(
      'subscriptionSelector.title',
      'Select a Subscription',
      { isNextGenTranslations: true }
    )
    const mySubscriptionTitle = i18nTranslate(
      'subscriptionSelector.subscriptionListHeader',
      'My Subscriptions',
      { isNextGenTranslations: true }
    )

    return (
      <Modal
        onHide={handleSelectSubscriptionModalClose}
        show={showModal}
        className="select-subscription-modal-wrapper"
        data-testid="qa-subscription-group-modal">
        <Modal.Header
          closeButton
          className="select-subscription-modal-header"
          data-testid="qa-subscription-group-modal-header">
          <Modal.Title
            className="select-subscription-title"
            data-testid="qa-subscription-group-modal-title">
            {selectSubscriptionTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="select-subscription-modal-body"
          data-testid="qa-subscription-group-modal-body">
          <h5
            className="my-subscription-title"
            data-testid="qa-subscription-group-title">
            {mySubscriptionTitle}
          </h5>
          <div className="select-subscription-wrapper">
            <div className="subscription-list">
              {this.renderExistingSubscriptionList()}
            </div>
            <div className="subscription-fixed">
              {this.renderNewSubscriptionOption()}
              {this.renderContinueButton()}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

export { MultipleSubscriptionCart }
export default MultipleSubscriptionCart
